<template>
	<div class="raports-details-wrapper">
		<v-dialog v-model="showdetailsdialog" hide-overlay scrollable transition="dialog-bottom-transition" fullscreen>
			<v-card>
				<v-toolbar dark color="primary">
					<v-toolbar-title>
						{{ getStateWithParam('report_details') }}
						<span v-if="showdetailsdialog && item"> - {{ item.rid }}</span>
					</v-toolbar-title>
					<v-btn icon dark @click="$router.back()">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-card-text v-if="showdetailsdialog && item">
					<div class="raport-details-img-wrapper">
						<div v-if="show_photos" @click="openfotoFullModal()">
							<hooper :key="hopper_view_detail" :progress="true" :infiniteScroll="true">
								<slide v-for="(photo, index) in photos" :key="index + 1000">
									<v-img :src="photo" aspect-ratio="1.7"></v-img>
								</slide>
								<hooper-progress slot="hooper-addons"></hooper-progress>
								<hooper-pagination slot="hooper-addons"></hooper-pagination>
							</hooper>
						</div>
						<template>
							<div @click="refreshMap" class="raports-details-map">
								<BaseAccordionCard :expanded="false" :toggable="showmap" :accordion_header="item.adresa">
									<template v-if="showmap" v-slot:component>
										<MapCard id="raports-details-map" ref="map_in_raport_detail" :key="map_key_view_raport" class="raports-details-map" :enablelocation="false" :fitbounds="fitbounds">
											<l-marker :lat-lng="map_marker" :icon="map_helper.getIcon(icon_url)"></l-marker>
										</MapCard>
									</template>
									<!-- <template v-slot:component2>
										<ReportDetailsInfo />
									</template> -->
									<template v-slot:icon>
										<v-icon class="raports-details-icon pr-2" color="primary">location_on</v-icon>
									</template>
								</BaseAccordionCard>
							</div>
						</template>
					</div>

					<div class="raport-details-contaner">
						<v-layout column>
							<div class="map-details">
								<v-timeline>
									<TimeLineItem
										:key="timeline_raport"
										:pershkrimi="item.pershkrimi"
										:data_in="item.data_in"
										:status_date="item.status_date"
										:notes="item.notes"
										:show_photos="show_photos"
										:photos="photos"
										:notesphotos="notesphotos"
										:show_notes_photos="show_notes_photos"
										v-on:openFoto="openfotoFullModal"
									/>

									<TimeLineItem
										v-for="item in item_report_reply_local"
										:key="item.data_in"
										:pershkrimi="item.pershkrimi"
										:data_in="item.data_in"
										:status_date="item.status_date"
										:notes="item.notes"
										:show_photos="item.photos == []"
										:photos="item.photos"
										v-on:openFoto="openfotoFullModal"
									/>
								</v-timeline>
							</div>
							<v-btn v-if="show_reply_report_local" class="replay-btn" @click="openReplay" :class="{ 'replay-btn-close': replay }">
								{{ getStateWithParam('replay') }}
								<v-icon right dark>send</v-icon>
							</v-btn>
							<MakeReport v-if="show_reply_report_local && replay" class="replay-close" :raport_id_replay="show_reply_report_local ? item.rid : ''" :class="{ 'replay-open': replay }" />
						</v-layout>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-if="show_photos || show_notes_photos" v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" @close="photostoshow = null">
			<v-card tile>
				<v-toolbar absolute class="header-report-img-details" color="transparent">
					<v-btn icon @click="$router.back()">
						<v-icon color="white">close</v-icon>
					</v-btn>
				</v-toolbar>
				<div class="carousel-report-details">
					<v-carousel :key="updatePhotoCarusel" :cycle="false" :hide-controls="dialogphotos.length == 1">
						<v-carousel-item v-for="(photo, i) in dialogphotos" :key="i" class="lazyload" :src="photo"></v-carousel-item>
					</v-carousel>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import MakeReport from '../make_report/MakeReport';
//import MapCard from '@/components/cards/MapCardController';
import MapCard from '@/components/cards/MapController.vue';
import { LMarker } from 'vue2-leaflet';
import TimeLineItem from '@/components/timeline/TimeLineItem';
//import ReportDetailsInfo from '@/components/cards/ReportDetailsInfo';
import reports from '@/config/api/api_events/reports';
import { SENSOR_DATA_DOMAIN } from '@/config/api/url/urls_in_app';
import map_helper from '@/config/js_helper/map_helper.js';

import { Hooper, Slide, Progress as HooperProgress, Pagination as HooperPagination } from 'hooper';
//import { async } from 'q';

export default {
	name: 'ViewReportDetail',
	props: {
		item: {
			type: [Object],
		},
		item_report_reply: {
			type: [Object, Array],
		},
		show_reply_report: {
			type: [Boolean],
			default: false,
		},
		showdetailsdialog: {
			type: [Boolean],
			default: false,
		},
		ismyreports: {
			type: [Boolean],
			default: false,
		},
	},
	components: {
		Hooper,
		Slide,
		MakeReport,
		HooperProgress,
		HooperPagination,
		MapCard,
		LMarker,
		TimeLineItem,
		//ReportDetailsInfo,
	},
	data() {
		return {
			from_where: 16,
			show_photos: false,
			show_notes_photos: false,
			//dialog: false,
			//item: this.item_report,
			item_report_reply_local: this.item_report_reply,
			show_reply_report_local: this.show_reply_report,
			hopper_view_detail: 6000,
			updatePhotoCarusel: 10,
			map_key_view_raport: 8000,
			replay: false,
			timeline_raport: 'timeline_raport',
			icon_url: require('@/assets/img/new_icons/njesi_administrative.svg'),
			map_marker: [41.3278, 19.8174],
			photos: [],
			notesphotos: [],
			map_helper: map_helper,
			fitbounds: 0,
			photostoshow: null,
		};
	},
	watch: {
		showdetailsdialog(newval) {
			if (newval) {
				this.getPhotosFormCall();
				this.updateMap();
				this.setCordinatePositionInMap();
			} else {
				this.photos = [];
				this.show_photos = false;
			}
		},
	},
	mounted() {
		//this.$store.state.active_loader = false;
		//this.getPhotosFormCall();
		this.hopper_view_detail += 1;
	},
	computed: {
		dialog() {
			return this.$route.name == 'ViewReportPhotos' || this.$route.name == 'ViewMyReportPhotos';
		},
		showmap() {
			return this.item && this.item.lat != '0' && this.item.lon != '0';
		},
		dialogphotos() {
			return this.photostoshow ? this[this.photostoshow] : this.photos;
		},
	},
	methods: {
		refreshMap() {
			map_helper.refreshMap();
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getPhotosFormCall() {
			this.getUserFotosWithIdAndUpdateMapAndCordinates();
		},
		getUserIdToPresentImageMyRaport() {
			if (this.item.user_id != undefined) {
				return '&user_id=' + this.item.user_id;
			}
		},
		openReplay() {
			this.replay = !this.replay;
			this.updatePhotoCarusel++;
		},
		updateMap() {
			this.$forceUpdate();
			this.hopper_view_detail += 1;
			this.map_key_view_raport += 1;
		},
		async getUserFotosWithIdAndUpdateMapAndCordinates() {
			await reports.getReportImage(this.item.id).then((data) => {
				if (data.posted.length > 0) {
					this.photos = data.posted.map((el) => {
						return SENSOR_DATA_DOMAIN + el + this.getUserIdToPresentImageMyRaport();
					});
					this.show_photos = true;
				} else {
					this.photos = [];
					this.show_photos = false;
				}
				if (data.solved.length > 0) {
					this.notesphotos = data.solved.map((el) => {
						return SENSOR_DATA_DOMAIN + el + this.getUserIdToPresentImageMyRaport();
					});
					this.show_notes_photos = true;
				} else {
					this.notesphotos = [];
					this.show_notes_photos = false;
				}
			});
		},
		setCordinatePositionInMap() {
			this.map_key_view_raport += 1;
			if (this.showmap) {
				this.map_marker = [this.item.lat, this.item.lon];
				this.fitbounds++;
			}
		},
		changeHooper() {
			this.hopper_view_detail += 1;
		},
		openfotoFullModal(event) {
			this.photostoshow = event && event.type ? event.type : null;
			this.changeHooper();
			this.updatePhotoCarusel++;
			//this.dialog = !this.dialog;
			let routename = this.ismyreports ? 'ViewMyReportPhotos' : 'ViewReportPhotos';
			this.$router.push({ name: routename });
		},
	},
};
</script>

<style scope lang="scss" src="./ViewReportDetail.scss"></style>
